import React from 'react';
import {observer} from "mobx-react";
import styles from "../../styles/game-center-widget.module.scss";
import classNames from "classnames";
import {PointByPointWidgetAsync} from "../../../point-by-point-widget/components/point-by-point-widget.async";

export const GameCenterWidgetPointByPointNewsTab = observer(({controller, gameId}) => {
  const {state} = controller;
  const {shouldRenderPointByPoint} = state;

  const newsProps = {
    gameId,
    controller
  }

  return shouldRenderPointByPoint ? <div className={classNames(styles.widget_wrapper)}>
    <PointByPointWidgetAsync {...newsProps}/>
  </div> : null
});
